import BannerComponent from "../components/Banner.component";
import DocumentComponent from "../components/Document.component";
import ScheduleComponent from "../components/Schedule.component";
import i18n from "../i18n"
import {Container, Row, Col, Card, Button} from "react-bootstrap";
import {NavLink} from "react-router-dom";
import 'react-image-gallery/styles/css/image-gallery.css';
import {getUrlLangPrefix} from "../utils/Local";
import {trackEvent} from "../components/GA.component";

export default function GalleryPage() {

    const {t} = i18n;

    const langPrefix = getUrlLangPrefix()
    const items = [
        {
            title: t('Projects'),
            to: `${langPrefix}/${t('_route.projects')}/`,
            img: `https://cdn.pakville.ca/images/projects/2024-07-01-PakNewYork-Backyard-Suite/1-thumbnail.jpg`,
        },
        {
            title: t('Events'),
            to: `${langPrefix}/${t('_route.events')}`,
            img: `https://cdn.pakville.ca/images/events/2025_Dans_l_oeil_du_dragon/5_dragon.jpg`,
        },
        {
            title: t('Awards'),
            to: `${langPrefix}/${t('_route.awards')}`,
            img: `https://cdn.pakville.ca/images/awards/2024_Batimatech/03-Thumb.jpg`,
        }
    ];

    return (<>

        <DocumentComponent title={t('gallery')}/>
        <BannerComponent title={t('gallery')} description={t('gallery_description')}/>

        <Container>
            <Row>
                {items.map((item, index) => (
                    <Col xs={12} lg={4} key={index} className="mb-3">
                        <NavLink to={item.to} onClick={() => {
                            trackEvent({
                                category: 'Gallery',
                                action: 'Navigate',
                                label: item.title,
                            });
                        }}>
                            <Card className="p-0 h-100 shadow-lg border-0">
                                <Card.Img variant="top" src={item.img} alt={item.title}/>
                                <Card.Footer style={{background: 'unset', border: 'unset'}} className=" mb-2">
                                    <Button
                                        variant="outline-primary d-flex justify-content-center gap-2 ps-4 pe-4 pt-2 pb-2 w-100">
                                        <span>{item.title}</span>
                                    </Button>
                                </Card.Footer>
                            </Card>
                        </NavLink>
                    </Col>

                ))}
            </Row>

        </Container>

        <ScheduleComponent/>

        <br/>
        <br/>
        <br/>

    </>)
}
